<template>
  <span
    v-if="dealerUserStore.store"
    :title="dealerUserStore.store.name"
    v-text="dealerUserStore.store.id"
  />
  <span v-else v-text="'-'" />
</template>

<script setup>
  import { computed, watch, onMounted } from 'vue';
  import { useUserStore } from '~~/common/stores/user';
  import { useAuchanStoresStore } from '~~/dealer/app/stores/auchanStore';

  const auchanStoresStore = useAuchanStoresStore();
  const { fetchDealerUserStore } = auchanStoresStore;
  const userStore = useUserStore();

  const dealerUserStore = computed(() => {
    return auchanStoresStore.dealerUserStore;
  });
  const user = computed(() => {
    return userStore.data;
  });

  onMounted(fetchDealerUserStore);

  watch(user, fetchDealerUserStore);
</script>
